<template>
    <div>
        <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
            <CCol sm="12" @click="GoToSetting()">
                <img src="../assets/img/arrow-left.png" style="max-width:18px;" class="float-left"/>
                <h3 class="custom-18px-500 font-color-171717" style="padding-left: 25px;">Back</h3>
            </CCol>
            <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <CRow class="m-2">
                    <CCol sm="12" md="12" lg="12" class="text-center p-2">
                        <CRow>
                            <CCol sm="6">
                                <div class="p-2 text-left">
                                    <h3 class="custom-18px-500 text-left">Yearly Form</h3>
                                </div>
                            </CCol>
                            
                        </CRow>
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="10">
                                <CRow class="text-left">
                                   
                                    <CCol sm="12">
                                        <label class="custom-14px-500 font-color-171717 mt-1">EA Form (EA Person in Charge)</label>
                                        <v-select v-model="SelectedStaff" :options="staff" label="FullName" class="custom-border-form"></v-select>
                                    </CCol>
                                </CRow>
    
                            </CCol>
                            <CCol sm="2" class="mt-4">
                                <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="UpdateEmployeeYearlyForm">
                                Save</CButton>
                            </CCol>
                        </CRow>
    
    
                    </CCol>
    
                </CRow>
            </CCard>



            <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <CRow class="m-2">
                    <CCol sm="12" md="12" lg="12" class="text-center p-2">
                        <table class="table table-responsive-sm text-left" v-if="Array.isArray(filteredyearlyTableData) && filteredyearlyTableData.length > 0">
                            <thead class="custom-table">
                                <th>Name</th>
                                <th></th>
                            </thead>
                            <tbody v-for="item in yearlyform" v-bind:key="item.Id">
                                <tr>
                                    <td>{{ item.name }}</td>
                                    <td class="text-right"><img :src="require('@/assets/img/delete.png')" alt="View" style="cursor: pointer; width:30px" class="ml-2" @click="DeleteForm(item.title,item.name)"/></td>
                                </tr>
                                
                            </tbody>
                        </table>
                        <div v-else class="no-data-message">
    
                            <div class="full-height-container">
                                <div class="no-data-message">
                                    <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;" />
                                    <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
                                </div>
                            </div>
    
                        </div>
                    </CCol>
    
                </CRow>
            </CCard>
        </CCol>
        <div v-if="OpenAddDepartment" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left font-inter">Add Department</h3>
                    </CCol>
                    <CCol sm="2" class="text-right"><img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupAddDepartment" /></CCol>
                </CRow>
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Department Name</h3>
                                <CInput type="text" />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Code</h3>
                                <CInput type="text" />
                            </CCol>
    
    
                        </CRow>
                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half mt-3" block>
                                Submit</CButton>
    
                    </div>
                </CCol>
            </div>
        </div>

        <div v-if="isPopupSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                        Your data has been submitted successfully.
                    </h3>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
            </div>
    </div>
    </div>
</template>




<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {

            OpenAddDepartment: false,

            staff: [],
            SelectedStaff: "",

            isPopupSuccess: false,
            filteredyearlyTableData: [],
            yearlyform: [],



        }





    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();
                await this.GetListStaff();
                await this.GetListEmployeeYearlyForm();

            } else {
                this.GoToPage();
            }
        } catch (error) {
            this.GoToPage();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },

    computed: {

    },
    created() {},
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },

        openDepartment() {
            this.OpenAddDepartment = true;
        },

        closePopupAddDepartment() {
            this.OpenAddDepartment = false;
        },
        GoToSetting()
        {
            this.$router.push("Setting");
        },
        async GetListStaff() {
            try {
                const response = await this.$API.get(this.$GetListAllStaffWoFilter, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.staff = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        UpdateEmployeeYearlyForm: function(Id) {
            const formData = new FormData();

            formData.append("EmployeeId", this.SelectedStaff.Id);
            formData.append("Status", true);

            return this.$API
                .post(this.$InsertEmployeeYearlyFormSetting, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.Busy = false;
                        this.isPopupSuccess = true;
                        this.GetListNotification();
                    } else {
                        this.Busy = false;
                        this.$dialog.alert("Error to add").then(function() {});
                    }
                })
                .catch((error) => {
                    this.Busy = false;
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        async GetListEmployeeYearlyForm() {
            try {
                const response = await this.$API.get(this.$GetListEmployeeYearlyForm, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.yearlyform = response.data;
                    this.filteredyearlyTableData = this.yearlyform;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        closeSuccess()
        {
            this.isPopupSuccess = false;
        },
        



    }

};
</script>